import { FC, ReactElement } from 'react';

import { css } from '@emotion/react';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Typography } from '@mui/material';

import ZendeskLoader from './ZendeskLoader';

const ZendeskLink: FC<{
  loadingText?: string;
  text?: string;
  textColor?: string;
}> = ({ loadingText = 'Loading...', text = 'Chat with us', textColor }) => {
  const generateUI = (text: string): ReactElement => {
    return (
      <Typography
        color={textColor}
        variant="body2"
        css={{ display: 'flex', alignItems: 'center', paddingLeft: 0 }}
      >
        <ChatBubbleOutlineIcon
          fontSize="small"
          css={{ marginRight: '0.5rem' }}
        />
        {text}
      </Typography>
    );
  };

  return (
    <ZendeskLoader
      loadingIndicator={generateUI(loadingText)}
      styles={css({ padding: 0 })}
    >
      {generateUI(text)}
    </ZendeskLoader>
  );
};

export default ZendeskLink;
